__webpack_require__.p = "https://static.highsnobiety.com/interactive-stories/New-Balance_Maleigh-Zan-21-05-24/";